import { render } from "./verification_code.vue?vue&type=template&id=fb989bc8&scoped=true"
import script from "./verification_code.vue?vue&type=script&lang=js"
export * from "./verification_code.vue?vue&type=script&lang=js"

import "./verification_code.vue?vue&type=style&index=0&id=fb989bc8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb989bc8"]])

export default __exports__